import React, { useRef } from 'react';
import './Style.css';
import { Link } from 'react-router-dom';
import ImageIcon from '@material-ui/icons/Image';
import LibraryImage from '../../../Assets/Photos/ImageGallary.png';
import LibraryImage2 from '../../../Assets/Photos/317-3172926_angry-birds-clipart-angry-birds-friends-angry-birds-angry-birds-circular.png';
import LibraryImage3 from '../../../Assets/Photos/13a71472f31f0ec3f38adcc0bfacf17e.png';

import { ImageComponent } from '../../../Components';
const Index = ({ alt = false, setImage, setStateFalse }) => {
    const inputRef = useRef();
    return (
        <div className="image_library">
            <div className="image_library_head">
                <h1 className="image_library_heading">Image Library</h1>
                <Link className="image_library_link" to="/guideLines" target="_blank">
                    Important guidelines to read before uploading
                </Link>
                <label
                    onClick={() => {
                        inputRef.current.click();
                    }}
                    htmlFor="upload-image-input-libaray"
                >
                    <input
                        ref={inputRef}
                        id="upload-image-input-libaray"
                        type="file"
                        multiple={false}
                        accept="image/*"
                        name="upload-image-input-libaray"
                        className="upload-image-hide"
                    />
                    <button className="btn-orange">
                        <ImageIcon className="btn-icon" />
                        <p>Upload Your Image</p>
                    </button>
                </label>
            </div>
            <div className="image_library_container">
                <ImageComponent
                    setStateFalse={setStateFalse}
                    alt={alt}
                    setImage={setImage}
                    text="Holi Maskoid02.jpg"
                    image={LibraryImage}
                />
                <ImageComponent
                    setStateFalse={setStateFalse}
                    alt={alt}
                    setImage={setImage}
                    text="angry_birds_movie_2016-wave.png"
                    image={LibraryImage2}
                />
                <ImageComponent
                    setStateFalse={setStateFalse}
                    alt={alt}
                    setImage={setImage}
                    text="Holi Maskoid02.jpg"
                    image={LibraryImage3}
                />
                <ImageComponent
                    setStateFalse={setStateFalse}
                    alt={alt}
                    setImage={setImage}
                    text="Holi Maskoid02.jpg"
                    image={LibraryImage}
                />
                <ImageComponent
                    setStateFalse={setStateFalse}
                    alt={alt}
                    setImage={setImage}
                    text="angry_birds_movie_2016-wave.png"
                    image={LibraryImage2}
                />
                <ImageComponent
                    setStateFalse={setStateFalse}
                    alt={alt}
                    setImage={setImage}
                    text="angry_birds_movie_2016-wave.png"
                    image={LibraryImage3}
                />
                <ImageComponent
                    setStateFalse={setStateFalse}
                    alt={alt}
                    setImage={setImage}
                    text="angry_birds_movie_2016-wave.png"
                    image={LibraryImage}
                />
                <ImageComponent
                    setStateFalse={setStateFalse}
                    alt={alt}
                    setImage={setImage}
                    text="Holi Maskoid02.jpg"
                    image={LibraryImage2}
                />
                <ImageComponent
                    setStateFalse={setStateFalse}
                    alt={alt}
                    setImage={setImage}
                    text="Holi Maskoid02.jpg"
                    image={LibraryImage3}
                />
                <ImageComponent
                    setStateFalse={setStateFalse}
                    alt={alt}
                    setImage={setImage}
                    text="angry_birds_movie_2016-wave.png"
                    image={LibraryImage}
                />
            </div>
        </div>
    );
};

export default Index;
